import { useEffect } from "react";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";
import useApplause from "@/hooks/useApplause";

export default ({ enabled = true }) => {
  const { width, height } = useWindowSize();
  const { play } = useApplause();

  useEffect(() => {
    if (enabled) {
      play();
      console.log("Playing applause sound");
    }
  }, [enabled]);

  return (
    <div className="confetti">
      {enabled && (
        <Confetti
          width={width}
          height={height}
          numberOfPieces={200}
          recycle={true}
        />
      )}
    </div>
  );
};
